import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Icon } from "@iconify/react";
import { IconButton, ListItemIcon } from "@mui/material";

const ActionMenu = ({
  setDeleteCycle,
  setManageUser,
  setClone,
  handleCurrentData,
  data,
  setCreateCycle,
  setEditStatus,
  setStatus,
  setManage,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    handleCurrentData(data);
    setAnchorEl(event.currentTarget);
  };
  const handleDelete = () => {
    setAnchorEl(null);
    setDeleteCycle(true);
  };
  const handleManageUser = () => {
    setAnchorEl(null);
    setManageUser(true);
  };
  const handleClone = () => {
    setAnchorEl(null);
    setClone(true);
  };
  const handleEdit = () => {
    setCreateCycle(true);
    setAnchorEl(null);
    setEditStatus(true);
  };
  const handleStatus = () => {
    setAnchorEl(null);
    setStatus(true);
  };
  const handleManage = () => {
    setAnchorEl(null);
    setManage(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Icon icon="carbon:overflow-menu-vertical" width="20" height="20" />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem onClick={handleManage}>
          <ListItemIcon>
            <Icon icon="hugeicons:manager" width="20" height="20" />
          </ListItemIcon>
          Manage Appraisal
        </MenuItem>
        <MenuItem onClick={handleManageUser}>
          <ListItemIcon>
            <Icon icon="lucide:user-cog" width="20" height="20" />
          </ListItemIcon>
          Manage User
        </MenuItem>
        <MenuItem onClick={handleClone}>
          <ListItemIcon>
            <Icon icon="prime:clone" width="20" height="20" />
          </ListItemIcon>
          Clone
        </MenuItem>
        <MenuItem
          onClick={handleEdit}
          disabled={data.cycle_status === 2 ? true : false}
        >
          <ListItemIcon>
            <Icon icon="uil:edit" width="20" height="20" />
          </ListItemIcon>
          Edit Configuration
        </MenuItem>
        <MenuItem onClick={handleStatus}>
          <ListItemIcon>
            <Icon icon="pajamas:status" width="18" height="18" />
          </ListItemIcon>
          Cycle Status
        </MenuItem>
        <MenuItem sx={{ color: "red" }} onClick={handleDelete}>
          <ListItemIcon sx={{ color: "red" }}>
            <Icon icon="mdi-light:delete" width="20" height="20" />
          </ListItemIcon>
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ActionMenu;
